if (!customElements.get('fc-lineup-filter')) {
  customElements.define(
    'fc-lineup-filter',
    class FcLineupFilter extends HTMLElement {
      connectedCallback() {
        this.buttons = [...this.querySelectorAll('[data-lineup-filter]')];
        this.products = [...this.querySelectorAll('[data-lineup-vendor][data-lineup-groups]')];
        this.productRail = this.querySelector('[data-lineup-products]');
        this.count = this.querySelector('[data-lineup-count]');

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.applyFilter(button));
        });
      }

      applyFilter(selectedButton) {
        const filter = selectedButton.dataset.lineupFilter;
        const filterType = selectedButton.dataset.lineupFilterType;
        let visibleCount = 0;

        this.buttons.forEach((button) => {
          const isActive = button.dataset.lineupFilter === filter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        this.products.forEach((product) => {
          const productGroups = product.dataset.lineupGroups.split(/\s+/).filter(Boolean);
          const isVisible =
            filterType === 'all' ||
            (filterType === 'group' && productGroups.includes(filter)) ||
            (filterType === 'vendor' && product.dataset.lineupVendor === filter);
          product.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        if (this.count) {
          this.count.textContent = `${visibleCount} ${visibleCount === 1 ? 'product' : 'products'}`;
        }

        if (this.productRail) {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.productRail.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
    }
  );
}
